import {Component} from "@angular/core";
import {BasicConfiguration} from "src/app/model/configuration/configuration";
import {i18nService} from "src/app/service-utils/i18n.service";
import {AccountsApiService} from "../../api/accounts-api.service";
import {MessageService} from "../../utils/message/message.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.scss']
})
export class AdminSettingsComponent {

  isReturn: boolean;
  inform: boolean;
  email: string;
  configuration: string;
  bias = BasicConfiguration.BIAS;
  ascon = BasicConfiguration.ASCON;
  degree: number;
  hsa: number;
  isDegreeValid: boolean = true;
  isHsaValid: boolean = true;

  constructor(
    private accountsApi: AccountsApiService,
    private message: MessageService,
    private i18n: i18nService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.accountsApi.getReturn().subscribe(value => this.isReturn = value);
    this.accountsApi.getInform().subscribe(inform => this.inform = inform);
    this.accountsApi.getEmail().subscribe(response => this.email = response.httpError.error.text);
    this.accountsApi.getBasicConfiguration().subscribe(response => this.configuration = response.httpError.error.text);
    this.accountsApi.getDegree().subscribe(degree => this.degree = degree);
    this.accountsApi.getHsa().subscribe(hsa => this.hsa = hsa);
  }

  goBack(){
    this.router.navigate(['/admin']);
  }

  switchReturn() {
    let request = this.accountsApi.switchReturn();
    request.subscribe((response) => {
      if (response) {
        this.message.info("Successfully switched return");
      } else {
        this.message.error("Failed to switch return");
      }
    });
  }

  switchInform() {
    let request = this.accountsApi.switchInform();
    request.subscribe((response) => {
      if (response) {
        this.message.info("Successfully switched email notification");
      } else {
        this.message.error("Failed to switch email notification");
      }
    });
  }

  changeEmail(email: string) {
    if (this.checkEmail(email)) {
      let request = this.accountsApi.editEmail(email);
      request.subscribe((response) => {
        if (response) {
          this.message.info("Email has been changed");
        } else {
          this.message.error("Failed to change email");
        }
      });
    } else {
      this.message.error("Email not valid");
    }
  }

  switchConfiguration() {
    let request = this.accountsApi.switchBasicConfiguration();
    request.subscribe((response) => {
      if (response) {
        this.message.info("Successfully switched configuration");
      } else {
        this.message.error("Failed to switch configuration");
      }
    });
  }

  changeDegree(degree: number) {
    if (degree >= 15 && degree <= 35) {
      let request = this.accountsApi.setDegree(degree);
      request.subscribe((response) => {
        if (response) {
          this.message.info("Default degree has been changed");
        } else {
          this.message.error("Failed to change default degree");
        }
      });
      this.isDegreeValid = true;
    } else {
      this.isDegreeValid = false;
    }
  }

  changeHsa(hsa: number) {
    if (hsa >= 5 && hsa <= 35) {
      let request = this.accountsApi.setHsa(hsa);
      request.subscribe((response) => {
        if (response) {
          this.message.info("Default hsa has been changed");
        } else {
          this.message.error("Failed to change default hsa");
        }
      });
      this.isHsaValid = true;
    } else {
      this.isHsaValid = false;
    }
  }

  checkEmail(value){
    const emailRegexp = /^[\w\-.+]+@[a-zA-Z0-9.\-]+\.[a-zA-z0-9]{2,4}$/;
    return !value || emailRegexp.test(value);
  }

  getLimitsFormatted(rangeMin: number, rangeMax: number) {
    return {
      rangeMin: rangeMin,
      rangeMax: rangeMax
    }
  }

  getFieldFormatted(field: string) {
    return {
      field: field
    }
  }
}

